import { Link, NavLink } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { cn } from 'cn';
import { navItemsFor } from 'config/nav';
import Search from './Search';
import { Button, buttonVariants } from './ui/button';
import AccountMenu from './nav/AccountMenu';
import MobileNav from './nav/MobileNav';
import { useNavContext } from './nav/useNavContext';
import { useTheme } from 'lib/theme';

export default function Nav() {
    const { darkMode, toggleDarkMode } = useTheme();
    const ctx = useNavContext();

    return (
        <header className="w-full py-3 sm:py-4 lg:py-6">
            <div className="mx-auto flex w-full max-w-[100vw] items-center justify-between gap-2 px-4">
                <Link to="/" className="shrink-0" aria-label="Ultiverse home">
                    <img
                        src={
                            darkMode
                                ? '/assets/ultiverse-full-logo-dark.svg'
                                : '/assets/ultiverse-full-logo-light.svg'
                        }
                        alt="Ultiverse"
                        className="hidden h-8 md:block"
                    />
                    <img
                        src={
                            darkMode
                                ? '/assets/ultiverse-logo-dark.svg'
                                : '/assets/ultiverse-logo-light.svg'
                        }
                        alt="Ultiverse"
                        className="block h-8 md:hidden"
                    />
                </Link>

                <div className="mx-2 max-w-2xl min-w-0 flex-1 md:flex-[0.7]">
                    <Search isResultsPanel={false} />
                </div>

                <div className="hidden items-center gap-1 md:flex">
                    <nav className="flex items-center gap-1">
                        {navItemsFor('primary', ctx).map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={({ isActive }) =>
                                    cn(
                                        buttonVariants({ variant: 'ghost' }),
                                        isActive && 'bg-accent text-accent-foreground'
                                    )
                                }>
                                {item.title}
                            </NavLink>
                        ))}
                    </nav>
                    <Button
                        variant="outline"
                        size="icon"
                        className="mx-1"
                        aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                        onClick={toggleDarkMode}>
                        {darkMode ? <Sun className="size-4" /> : <Moon className="size-4" />}
                    </Button>
                    <AccountMenu />
                </div>

                <div className="md:hidden">
                    <MobileNav />
                </div>
            </div>
        </header>
    );
}
